import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild, OnInit, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MaterialModule } from '../../material/material.module';

@Component({
  selector: 'app-tabla-reusable',
  standalone: true,
  imports: [CommonModule, FormsModule, MaterialModule],
  templateUrl: './tabla-reusable.component.html',
  styleUrls: ['./tabla-reusable.component.scss']
})
export class TablaReusableComponent implements AfterViewInit, OnInit, OnChanges {

  @Input() acciones = false;
  @Input() columnas: any[] = [];
  @Input() datos: any[] = [];

  @Input() canEliminarCompra: ((compra: any) => boolean) | null = null;
  @Input() puedeCambiarPassword = false;
  @Input() puedeEditar = false;
  @Input() puedeEliminar = false;
  @Input() puedePagar = false;
  @Input() puedeVer = false;
  @Input() mostrarBuscador = true;

  @Input() accionesTemplate?: TemplateRef<any>;

  @Output() onCambiarPassword = new EventEmitter<any>();
  @Output() onEditar = new EventEmitter<any>();
  @Output() onEliminar = new EventEmitter<any>();
  @Output() onPagar = new EventEmitter<any>();
  @Output() onVer = new EventEmitter<any>();

  filtroTexto: string = '';
  sinResultados: boolean = false;

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  ngOnInit() {

    this.displayedColumns = this.columnas.map(c => c.field);
    if (this.acciones) {
      this.displayedColumns.push('acciones');
    }
    this.setDisplayedColumns();

    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filterLower = filter.trim().toLowerCase();
      return this.columnas.some(col => {
        const value = data[col.field];
        if (value === null || value === undefined) return false;
        return value.toString().toLowerCase().includes(filterLower);
      });
    };
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['columnas'] || changes['acciones'] || changes['puedeVer'] || changes['puedeEditar'] || changes['puedeEliminar']) {
      this.setDisplayedColumns();
    }

    if (changes['datos']) {
      this.actualizarDatos(this.datos);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  actualizarDatos(datos: any[]) {
    this.dataSource.data = datos;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filtroTexto = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    setTimeout(() => this.verificarResultados());
  }

  cambiarPassword(row: any) {
    this.onCambiarPassword.emit(row);
  }

  delete(row: any) {
    this.onEliminar.emit(row);
  }

  edit(row: any) {
    this.onEditar.emit(row);
  }

  extraerJsonDeTexto(texto: string): any[] {
    try {
      const match = texto.match(/\[.*\]/);  // Extrae el texto entre corchetes []
      return match ? JSON.parse(match[0]) : [];
    } catch (error) {
      console.error('Error al parsear JSON en detalle:', error);
      return [];
    }
  }

  extraerRolId(texto: string): number | null {
    const match = texto.match(/Rol ID: (\d+)/);
    return match ? +match[1] : null;
  }

  noData(): boolean {
    return !this.dataSource || this.dataSource.filteredData.length === 0;
  }

  pagarProducto(row: any) {
    this.onPagar.emit({ idCompra: row.idCompra, state: row.state });
  }

  setDisplayedColumns() {
    this.displayedColumns = this.columnas.map(c => c.field);
    if (this.acciones && (this.puedeVer || this.puedeEditar || this.puedeEliminar || this.puedePagar)) {
      this.displayedColumns.push('acciones');
    }
  }

  verificarResultados() {
    this.sinResultados = this.dataSource.filteredData.length === 0 && this.filtroTexto.trim().length > 0;
  }

  ver(row: any) {
    this.onVer.emit(row);
  }

  getInitials(nombre: string): string {
    if (!nombre) return '';
    const parts = nombre.trim().split(/\s+/);
    if (parts.length > 1) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return parts[0][0].toUpperCase();
  }

  getAvatarGradient(nombre: string): string {
    if (!nombre) return 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
    const charCodeSum = nombre.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
    const index = charCodeSum % 5;
    const gradients = [
      'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', // Blue
      'linear-gradient(135deg, #10b981 0%, #047857 100%)', // Emerald
      'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', // Amber
      'linear-gradient(135deg, #ec4899 0%, #be185d 100%)', // Pink
      'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)'  // Purple
    ];
    return gradients[index];
  }
}
